













import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import myTable from '../../components/table/my-table.vue'
import {GetHDPrescriptInfo} from '../../api/realTime'
@Component({
    components: {myTable}
})
export default class extends AbpBase {
    @Prop({type:Number}) id:any;
    created(){
        this.getData()
    }
    get height(){
        return window.innerHeight-220
    }
    async getData(){
        let res = await GetHDPrescriptInfo({patientId:this.id})
        this.list = res.data
    }
    detailShow = false
    detailData = {}
    list = []
    columns = [
        {title:'制定时间',key:'formulateDate'},
        {title:'透析频次',key:'dialysisFrequency'},
        {title:'治疗方式',key:'treatmentCode'},
        {title:'说明',key:'description'},
        {title:'透析液钙浓度',key:'calciumConcetration'},
        {title:'状态',key:'isEnable'},
        {title:'治疗医院',key:'hosptialName'},
    ]
}
